import { render, staticRenderFns } from "./UsersExternalAccessTable.vue?vue&type=template&id=af305254&scoped=true"
import script from "./UsersExternalAccessTable.vue?vue&type=script&lang=js"
export * from "./UsersExternalAccessTable.vue?vue&type=script&lang=js"
import style0 from "./UsersExternalAccessTable.vue?vue&type=style&index=0&id=af305254&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af305254",
  null
  
)

export default component.exports